import { ButtonPrimary, StepIndicator, typographyRem } from '@by-miles/bymiles-styles'
import { isEmpty } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { quoteId } from '../../cache'
import { AccessibleFormWrapper } from '../../components/AccessibleFormWrapper'
import LoadingMask from '../../components/LoadingMask'
import { CoverYourInsurance } from '../../components/QuoteFlow/Cover/CoverYourInsurance'
import { PaymentType } from '../../generated/graphql'
import { BasePage, BasePageProps } from '../../HOCs/BasePage'
import { updateQuoteMutation } from '../../hooks'
import { ProviderContext } from '../../Provider'
import { handleQuoteProgress } from '../../utils/handleQuoteProgress'
import { quoteSteps } from '../../utils/steps'
import { usePreQuoteContext } from '../PageValidator'
import { EntryStepsStyles } from '../styles/EntryStepsStyles'
const { hero: Hero } = typographyRem

export interface CoverActionsProps {
  setInceptionDate?: { inceptionDate: string }
  setPaymentType?: { paymentType: PaymentType }
  setVoluntaryExcess?: { voluntaryExcess: number }
  setCurrentRenewalPrice?: { current: number }
}

const Cover = ({ quote, pageName }: BasePageProps) => {
  const history = useHistory()
  const { updateQuote } = updateQuoteMutation()
  const {
    setIsFetching,
    redirectCheckout,
    state: { isFetching },
  } = useContext(ProviderContext)
  const { validateTransition } = usePreQuoteContext()
  const [coverActions, setCoverActions] = useState<CoverActionsProps>({})
  const id = quoteId() || ''

  useEffect(() => {
    const target = window.location.pathname
    const status = quote?.status?.sections
    const progress = handleQuoteProgress(status, target)
    if (target !== progress && progress) {
      history.push(progress)
    }
  }, [])

  const handleSaveCoverDetails = async (valid: boolean, step?: string) => {
    if (!isEmpty(coverActions)) {
      setIsFetching(true)
      await updateQuote({
        variables: {
          id,
          actions: [
            {
              ...coverActions,
            },
          ],
        },
      })
      setIsFetching(false)
    }
    if (step === 'driver' || step === 'car') {
      history.push(`/details/${step}`)
      return
    }
    if (valid) {
      redirectCheckout('quote')
    }
  }

  const validateAndSave = (step?: string) => {
    let valid = true
    if (step === 'quote' || !step) {
      valid = validateTransition()
    }
    handleSaveCoverDetails(valid, step)
    return valid
  }

  return (
    <EntryStepsStyles>
      {isFetching && <LoadingMask />}
      <StepIndicator
        validateOnClick={(step: string) => validateAndSave(step)}
        steps={quoteSteps}
        preFilledStep="cover"
      />
      <Hero>Your insurance cover.</Hero>
      <AccessibleFormWrapper className="entry-step-component-wrapper" onSubmit={validateAndSave}>
        <CoverYourInsurance coverActions={coverActions} setCoverActions={setCoverActions} />
        <ButtonPrimary
          type="submit"
          label="Get a quote"
          iconRight="IconArrowRight"
          shadow
          dataCy="confirm-cover-details"
          className="continue-button"
        />
      </AccessibleFormWrapper>
    </EntryStepsStyles>
  )
}

export default BasePage(Cover)
